import React from 'react';
import { Chip, Typography } from '@material-ui/core';
import {
  STATUS_OPTIONS,
  STATUS_COLORS,
  BACKGROUND_STATUS_COLORS,
  formatOodEditedBy,
} from '../../../utility/statusConfig';
import { formatDateTime, REVIEW_CHIP_STYLES } from './stalePriceReportConfig';

export default function StalePriceReviewStatusCell({ row }) {
  const statusId = row.manual_check_status_id;

  return (
    <>
      {statusId != null ? (
        <Chip
          size="small"
          label={STATUS_OPTIONS[statusId] || statusId}
          style={{
            color: STATUS_COLORS[statusId],
            backgroundColor: BACKGROUND_STATUS_COLORS[statusId],
          }}
        />
      ) : (
        <Chip size="small" label="Pending" style={REVIEW_CHIP_STYLES.pending} />
      )}
      {row.manual_check_edited_at && (
        <Typography variant="caption" display="block">
          {formatDateTime(row.manual_check_edited_at)}
          {(() => {
            const by = formatOodEditedBy(row.manual_check_edited_by, {
              statusId: row.manual_check_status_id,
            });
            return by ? ` · ${by}` : '';
          })()}
        </Typography>
      )}
    </>
  );
}
